import React, { useRef } from "react";

const SixDigitInput = ({ onComplete }) => {
  const inputRefs = [
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
  ];

  const handleChange = (e, index) => {
    const value = e.target.value.replace(/\D/g, "");

    if (value.length === 1 && index < 5) {
      inputRefs[index + 1].current.focus();
    }

    e.target.value = value;

    const code = inputRefs.map(ref => ref.current.value).join("");
    if (code.length === 6) {
      onComplete(code);
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !e.target.value && index > 0) {
      inputRefs[index - 1].current.focus();
    }
  };

  return (
    <div style={{ display: "flex", gap: "8px", justifyContent: "center", marginTop: "12px" }}>
      {inputRefs.map((ref, i) => (
        <input
          key={i}
          ref={ref}
          maxLength="1"
          inputMode="numeric"
          style={{
            width: "40px",
            height: "50px",
            fontSize: "24px",
            textAlign: "center",
            borderRadius: "6px",
            border: "1px solid #ccc"
          }}
          onChange={(e) => handleChange(e, i)}
          onKeyDown={(e) => handleKeyDown(e, i)}
        />
      ))}
    </div>
  );
};

export default SixDigitInput;